// 文章6数据信息
export default {
  id: 'dayunshan_106',
  content: `# 就冲这5点，所有人都该多把荞麦当主食！
  ![就冲这5点，所有人都该多把荞麦当主食1](https://cdn.keihong.tech/img/20250518213425192.jpg)

![就冲这5点，所有人都该多把荞麦当主食2](https://cdn.keihong.tech/img/20250518213430356.jpg)

![就冲这5点，所有人都该多把荞麦当主食3](https://cdn.keihong.tech/img/20250518213435409.jpg)

![就冲这5点，所有人都该多把荞麦当主食4](https://cdn.keihong.tech/img/20250518213438563.jpg)

![就冲这5点，所有人都该多把荞麦当主食5](https://cdn.keihong.tech/img/20250518213441595.jpg)

![就冲这5点，所有人都该多把荞麦当主食6](https://cdn.keihong.tech/img/20250518213444804.jpg)

![就冲这5点，所有人都该多把荞麦当主食7](https://cdn.keihong.tech/img/20250518213447727.jpg)

![就冲这5点，所有人都该多把荞麦当主食8](https://cdn.keihong.tech/img/20250518213451031.jpg)

![就冲这5点，所有人都该多把荞麦当主食9](https://cdn.keihong.tech/img/20250518213453992.jpg)

![就冲这5点，所有人都该多把荞麦当主食10](https://cdn.keihong.tech/img/20250518213457008.jpg)

![就冲这5点，所有人都该多把荞麦当主食11](https://cdn.keihong.tech/img/20250518213500152.jpg)

![就冲这5点，所有人都该多把荞麦当主食12](https://cdn.keihong.tech/img/20250518213503157.jpg)`
}
